var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"m-button",class:[
    _vm.type ? 'm-button--' + _vm.type : '',
    _vm.size ? 'm-button--' + _vm.size : '',
    { 'm-hairline--surround': _vm.isPlain },
    { 'm-button--full': _vm.full },
    { 'is-round': _vm.round },
    { 'is-plain': _vm.plain },
    { 'is-loading': _vm.loading },
    { 'is-disabled': _vm.disabled },
    { 'is-inline': _vm.inline },
  ],style:(_vm.styles),on:{"click":_vm.onClick}},[(_vm.icon && !_vm.loading)?_c('i',{staticClass:"m-icon m-button__icon",class:_vm.icon}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"m-button__loading"}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }